import {assetUrl, assetId} from './constants';

const day = (date, basemap) =>
  basemap ? '' : `.${('0' + date.getUTCDate()).slice(-2)}`;

const month = date => ('0' + (date.getUTCMonth() + 1)).slice(-2);

const format = (date, basemap) =>
  `${date.getUTCFullYear()}.${month(date)}${day(date, basemap)}`;

const setDates = json => {
  const dateA = new Date(json.frames[0].date);
  const dateB = new Date(json.frames[1].date);
  const basemap = json.frames[0].images[0].type === 'Basemap';

  document.getElementById('dateA').innerHTML = format(dateA, basemap);
  document.getElementById('dateB').innerHTML = format(dateB, basemap);
};

const getDates = async () => {
  try {
    const response = await fetch(`${assetUrl}/${assetId}/info.json`);
    setDates(await response.json());
  } catch (error) {
    // TODO: error
  }
};

export default getDates;
